/**
 * Created by christiancueni on 29/07/16.
 * Copyright (c) 2016 ITerativ GmbH. All rights reserved.
 */


import { UiActionTypes } from '../actions/ui';
import { CustomAction } from '../actions/CustomAction';
import { createSelector } from '@ngrx/store';


export interface UiState {
    showNavigation: boolean;
    title: string;
    contextMenuOpen: boolean; // used for mobile
    showBack: boolean;
    contextMenu: string;
    backUrl: string;
    appPart: string;
    language: string;
    forceContextDropdown: boolean;
    showNotifications: boolean;
}

export const initialUiState: UiState = {
    showNavigation: false,
    title: 'Helloclass',
    contextMenuOpen: false,
    showBack: false,
    contextMenu: '',
    backUrl: '',
    appPart: '',
    language: 'de',
    forceContextDropdown: false,
    showNotifications: false
};

export function reducer(state = initialUiState, action: CustomAction): UiState {
    switch (action.type) {
        case UiActionTypes.UI_SHOW_NAVIGATION:
            return Object.assign({}, state, {
                showNavigation: true
            });

        case UiActionTypes.UI_HIDE_NAVIGATION:
            return Object.assign({}, state, {
                showNavigation: false
            });

        case UiActionTypes.UI_SHOW_MENU:
            return Object.assign({}, state, {
                contextMenuOpen: true
            });

        case UiActionTypes.UI_HIDE_MENU:
            return Object.assign({}, state, {
                contextMenuOpen: false
            });

        case UiActionTypes.UI_SHOW_BACK:
            return Object.assign({}, state, {
                showBack: true
            });

        case UiActionTypes.UI_HIDE_BACK:
            return Object.assign({}, state, {
                showBack: false
            });

        case UiActionTypes.UI_SET_TITLE:
            return Object.assign({}, state, {
                title: action.payload
            });

        case UiActionTypes.UI_SET_CONTEXT_MENU:

            return Object.assign({}, state, {
                contextMenu: action.payload,
                forceContextDropdown: false
            });

        case UiActionTypes.UI_SET_BACK_URL:

            let showBack = action.payload !== '';

            return Object.assign({}, state, {
                backUrl: action.payload,
                showBack: showBack
            });

        case UiActionTypes.UI_SET_APP_PART:
            return Object.assign({}, state, {
                appPart: action.payload,
            });

        case UiActionTypes.UI_FORCE_CONTEXT_DROPDOWN:
            return Object.assign({}, state, {
                forceContextDropdown: true
            });

        case UiActionTypes.UI_LIBERATE_CONTEXT_DROPDOWN:
            return Object.assign({}, state, {
                forceContextDropdown: false
            });

        case UiActionTypes.UI_SET_LANGUAGE:
            return Object.assign({}, state, {
                language: action.payload
            });

        case UiActionTypes.UI_TOGGLE_NOTIFICATIONS:
            return Object.assign({}, state, {
                showNotifications: !state.showNotifications
            });

        case UiActionTypes.UI_HIDE_NOTIFICATIONS:
            return Object.assign({}, state, {
                showNotifications: false
            });

        case UiActionTypes.UI_RESET:
            return Object.assign({}, initialUiState);

        default: {
            return state;
        }
    }
}


export function isNavigationShown(state: UiState) {
    return state.showNavigation;
}

export function getTitle(state: UiState) {
    return state.title;
}

export const isContextMenuOpen = (state: UiState) => state.contextMenuOpen;

export const isContextMenuShown = createSelector(
    getContextMenu,
    (contextMenu) => contextMenu !== ''
)

export function isBackShown(state: UiState) {
    return state.showBack;
}

export function getContextMenu(state: UiState) {
    return state.contextMenu;
}

export function getBackUrl(state: UiState) {
    return state.backUrl;
}

export function getAppPart(state: UiState) {
    return state.appPart;
}

export function getForceContextDropdown(state: UiState) {
    return state.forceContextDropdown;
}

export function getLanguage(state: UiState) {
    return state.language;
}

export function isNotificationsShown(state: UiState) {
    return state.showNotifications;
}
